import i18next from 'i18next';
/**
 * RetentionPeriod Integration
 * Generated by AI
 */
import { toast } from 'sonner';
// TODO: Check store import
// import { useRetentionPeriodStore } from '@/store/retention-period.store.js';
import { Logger } from '@/lib/app-log.js';

export class RetentionPeriodIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        /*
        const store = useRetentionPeriodStore.getState();
        store.setLoading(true);
        */
        try {
            const response = await this.service.getAll(params);
            
            /*
            store.setItems(response.data);
            if (response.pagination) store.setPagination(response.pagination);
            */
            
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            /* store.setError(error.message); */
            return { success: false, error: error.message };
        } finally {
            /* store.setLoading(false); */
        }
    }

    async getById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('integrationToasts:createdSuccessfully', { defaultValue: 'Created successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('integrationToasts:updatedSuccessfully', { defaultValue: 'Updated successfully' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }

    async delete(id) {
        try {
            await this.service.delete(id);
            toast.success(i18next.t('integrationToasts:deletedSuccessfully', { defaultValue: 'Deleted successfully' }));
            return { success: true };
        } catch (error) {
            toast.error(error.message);
            return { success: false, error: error.message };
        }
    }
}
